import * as THREE from 'three'
import Experience from '../Experience'

export default class InteractionManager {
  constructor() {
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.camera = this.experience.camera
    this.sizes = this.experience.sizes

    this.raycaster = new THREE.Raycaster()
    this.mouse = new THREE.Vector2()
    this.interactableObjects = []

    // true の間はクリック/ホバーを無視する（Signalscope の覗き込み中など）
    this.suppressed = false

    this.setupEventListeners()
  }

  setupEventListeners() {
    window.addEventListener('click', (event) => {
      this.onMouseClick(event)
    })

    window.addEventListener('mousemove', (event) => {
      this.onMouseMove(event)
    })
  }

  onMouseClick(event) {
    if (this.suppressed) return

    this.updateMousePosition(event)
    this.performRaycast()

    const intersects = this.raycaster.intersectObjects(
      this.interactableObjects.map(obj => obj.mesh || obj)
    )

    if (intersects.length > 0) {
      const intersectedObject = intersects[0].object
      const interactableObject = this.findInteractableObject(intersectedObject)

      if (interactableObject && typeof interactableObject.onInteract === 'function') {
        interactableObject.onInteract(intersects[0])
      }
    }
  }

  onMouseMove(event) {
    if (this.suppressed) return

    this.updateMousePosition(event)
    this.performRaycast()

    const intersects = this.raycaster.intersectObjects(
      this.interactableObjects.map(obj => obj.mesh || obj)
    )

    // マウスホバー時の処理
    this.interactableObjects.forEach(obj => {
      if (typeof obj.onHoverExit === 'function') {
        obj.onHoverExit()
      }
    })

    if (intersects.length > 0) {
      const intersectedObject = intersects[0].object
      const interactableObject = this.findInteractableObject(intersectedObject)

      if (interactableObject && typeof interactableObject.onHover === 'function') {
        interactableObject.onHover(intersects[0])
      }
    }
  }

  updateMousePosition(event) {
    this.mouse.x = (event.clientX / this.sizes.width) * 2 - 1
    this.mouse.y = -(event.clientY / this.sizes.height) * 2 + 1
  }

  performRaycast() {
    this.raycaster.setFromCamera(this.mouse, this.camera.instance)
  }

  findInteractableObject(mesh) {
    return this.interactableObjects.find(obj => obj.mesh === mesh || obj === mesh)
  }

  addInteractableObject(object) {
    if (!this.interactableObjects.includes(object)) {
      this.interactableObjects.push(object)
    }
  }

  removeInteractableObject(object) {
    const index = this.interactableObjects.indexOf(object)
    if (index > -1) {
      this.interactableObjects.splice(index, 1)
    }
  }

  destroy() {
    window.removeEventListener('click', this.onMouseClick)
    window.removeEventListener('mousemove', this.onMouseMove)
  }
}